import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { ProjectUserDto } from 'projects/shared/src/lib/models/ProjectUser';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectService } from 'projects/shared/src/lib/services/project.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AgGridProjectUsersSettings } from './AgGridProjectUsersSettings';
import { ProjectUserButtonRendererComponent } from './project-user-button-renderer/project-user-button-renderer.component';

@Component({
  selector: 'project-user',
  templateUrl: './project-user.component.html',
  styleUrls: ['./project-user.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class ProjectUserComponent implements OnInit {
  @Input('project') project!:ProjectDto;

  rowData:ProjectUserDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridProjectUsersSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  _db!:string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private projectService: ProjectService,
    private tenantService: TenantService,
    public translate: TranslateService, 
    private oauthService: OAuthServiceService,   
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    // localStorage.setItem('project-id', this.project.id);
    this.tenantService.projectId = this.project.id;
    //localStorage.setItem('tenant-db', this.project.tenantName);

    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridProjectUsersSettings(this.translate);
    this.frameworkComponents = { buttonRenderer: ProjectUserButtonRendererComponent };
    this.gridOptions = this.aggridSettings.agGridProjectUsersSettings;
    
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });

    this.ds = {
      rowCount:0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'Role';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        // TODO if - else Unterscheidung rausnehmen
        if(this._db){
          let actTenant = this.tenantService.currentTenantName;
          this.tenantService.loadProjectUsers(actTenant, this.project.id, this.filter).subscribe({
//          this.projectService.loadProjectUsers(this.project.id, this.filter).subscribe({
            next:(projectUserDtos: ProjectUserDto[]) => {
              projectUserDtos.forEach(x => x.userName = (x.lastName != "confirmed)")?x.firstName + " " + x.lastName:x.email);
              console.log("=======> project-user: projectUsers 1 = ", projectUserDtos)
              this.rowData = projectUserDtos.slice(this.filter.startRow, this.filter.endRow);
              let lastRow = -1;
  
              if (this.rowData.length <= this.filter.endRow) {
                lastRow = this.rowData.length;
              }
              params.successCallback(this.rowData, lastRow);
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.resultsLength = this.rowData.length;
   
               this.gridApi.hideOverlay();
  
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERS"]} `);
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERSERROR"]}`)
            }
          });
        }
        else {
          let db:string = this.tenantService.currentTenantName;
          this.tenantService.loadProjectUsers(db, this.project.id, this.filter).subscribe({
            next:(projectUserDtos: ProjectUserDto[]) => {
              projectUserDtos.forEach(x => x.userName = (x.lastName != "confirmed)")?x.firstName + " " + x.lastName:x.email);
              console.log("=======> project-user: projectUsers 2 = ", projectUserDtos)
              this.rowData = projectUserDtos.slice(this.filter.startRow, this.filter.endRow);
              let lastRow = -1;
  
              if (this.rowData.length <= this.filter.endRow) {
                lastRow = this.rowData.length;
              }
              params.successCallback(this.rowData, lastRow);
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.resultsLength = this.rowData.length;
   
               this.gridApi.hideOverlay();
  
              //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERS"]} `);
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEDPROJECTUSERSERROR"]}`)
            }
          });          
        }
      }
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds)
  } 

  cancel() {
    this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-projects']);
  }

}
